import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { DailygridsColumns } from 'src/app/shared/model/dailygrids-column';
import { FeedService } from 'src/app/shared/service/feed.service';
import { UtilService } from 'src/app/shared/service/util.service';
import { ModifyColumnsDialogComponent } from './modify-columns-dialog/modify-columns-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-modify-dailygrids-columns',
  templateUrl: './modify-dailygrids-columns.component.html',
  styleUrls: ['./modify-dailygrids-columns.component.css']
})
export class ModifyDailygridsColumnsComponent implements OnInit {

  columns: DailygridsColumns[] = [];
  displayedColumns: string[] = ['code', 'columnName', 'field', 'actions'];
  dataSource = new MatTableDataSource<DailygridsColumns>();
  columnForm: FormGroup;
  isEditing: boolean = false;
  selectedColumnId?: number;

  constructor(private feedService: FeedService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private utilService: UtilService,
    private snackBar: MatSnackBar,
    private translate: TranslateService


  ) {

  }

  ngOnInit(): void {
    this.loadColumns();
  }


  loadColumns() {
    this.feedService.getAllDailygridsColumns().subscribe(
      (data) => {
        this.columns = data;
        this.dataSource.data = this.columns;  // Asignar datos a la tabla
      },
      (error) => {
        console.error('Error al cargar las columnad:', error);
      }
    );
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(ModifyColumnsDialogComponent, {
      width: '400px',
      data: { column: null, isEditing: false }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.loadColumns();
        }
      });
  }

  openEditDialog(column: DailygridsColumns) {
    const dialogRef = this.dialog.open(ModifyColumnsDialogComponent, {
      width: '400px',
      data: { column, isEditing: true }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.loadColumns();
        }

      });
  }

  async deleteColumn(id: number) {
    const textConfirm = await this.translateService.get('epg.users.dialog.messageDeleteConfirm').toPromise();
    const buttonConfirm = await this.translateService.get('epg.users.dialog.buttons.delete').toPromise();

    // Abrir el diálogo de confirmación
    const dialogRef = this.utilService.openConfirmDialog({
      title: buttonConfirm,
      text: textConfirm,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Si el usuario confirma, proceder a eliminar el idioma
        this.feedService.deleteDailygridsColumn(id).subscribe((response) => {
          this.translate.get("epg.configurationDailyColumns.snackbarSuccessDelete").subscribe((message) => {
            this.snackBar.open(message, "X", {
              duration: 3000,
              panelClass: ["SuccessfulSnackbar"],
            });
          });
          this.loadColumns();;

          console.log('Cambios guardados correctamente:', response);
        },
          (error) => {
            console.error('Error al guardar los cambios:', error);
            this.translate.get("epg.configurationDailyColumns.snackbarErrorDelete").subscribe((message) => {
              this.snackBar.open(message, "X", {
                duration: 3000,
                panelClass: ["error-snackbar"],

              });
            });
            this.loadColumns();;

          });
      }
    })
  }

  resetForm() {
    this.columnForm.reset();
    this.isEditing = false;
    this.selectedColumnId = undefined;
  }
}


